import { useNavigate } from 'react-router-dom'

import { Box, Grid, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { List, ListItem } from 'components/ui'
import { useMappedTranslation } from 'hooks'
import { Paper } from 'oneui'
import { IconStyle, SummaryPaperStyle } from 'styles/theme/theme'
import { EVENT_KEYS } from 'utils/constants'

import { getSecurityIcon } from '../../assets/images/securityIcon'
import IconSecurity from '../assets/images/security.svg'

const CombinedCard = (props) => {
  const { activity, passwordChangeDate, tsvEnabled } = props

  const t = useMappedTranslation()
  const navigate = useNavigate()
  const theme = useTheme()

  const handleDashboardSecurity = () => {
    navigate('/dashboard/security')
  }

  return (
    <Box
      tabIndex={0}
      onClick={handleDashboardSecurity}
      onKeyDown={(event) => {
        if (event.key === EVENT_KEYS.SPACE || event.key === EVENT_KEYS.ENTER) {
          event.preventDefault()
          handleDashboardSecurity()
        }
      }}
      sx={{ cursor: 'pointer' }}
      data-testid='BoxAF84465F'
    >
      <Paper
        sx={{
          ...SummaryPaperStyle,
          height: { xs: '100%', md: '400px' },
          minHeight: '320px',
          paddingBottom: { xs: '24px', md: '40px' }
        }}
      >
        <Stack justifyContent='flex-start' alignItems='center' sx={{ height: '100%' }}>
          <Grid container alignItems='center' wrap='nowrap' sx={{ width: '100%', marginBottom: { xs: '16px', md: '48px' } }}>
            <Box component='img' src={IconSecurity} sx={{ ...IconStyle }} alt='' />
            <Box sx={{ ml: { xs: '16px', md: '18px' } }}>
              <Typography
                fontSize={{ xs: '17px', md: '18px' }}
                fontWeight='bold'
                sx={{ textTransform: 'uppercase', overflowWrap: 'anywhere' }}
              >
                {t('security.title')}
              </Typography>
            </Box>
          </Grid>
          <Box sx={{ width: '100%' }}>
            <List sx={{ width: '100%', padding: { xs: '14px 0 16px', md: '18px 0' } }}>
              <ListItem
                icon={activity.icon}
                iconSx={{ ...IconStyle }}
                iconItemSx={{ minWidth: { xs: '52px', md: '56px' } }}
                title={
                  <Box pb={{ xs: '2px', md: '4px' }}>
                    <Typography
                      sx={{ fontSize: '12px', color: theme.palette.secondary.light, lineHeight: { xs: '16px', md: '14px' } }}
                    >
                      {t('security.recentActivity')}
                    </Typography>
                  </Box>
                }
                titleSx={{ minHeight: 0 }}
                description={
                  <Box sx={{ minHeight: { xs: '16px', md: '22px' } }}>
                    <Typography
                      sx={{ fontSize: '16px', lineHeight: { xs: '22px', md: '20px' }, fontWeight: 500, whiteSpace: 'pre-line' }}
                    >
                      {activity.description}
                    </Typography>
                  </Box>
                }
                fullWidth={true}
                hasUnderDivider={true}
                dividerSx={{ mt: { xs: '14px', md: '19px' }, mb: { xs: '16px', md: '19px' }, ml: { xs: '52px', md: '56px' } }}
              />

              <ListItem
                icon={getSecurityIcon('IconPassword', theme.palette.mode)}
                iconSx={{ ...IconStyle }}
                iconItemSx={{ minWidth: { xs: '52px', md: '56px' } }}
                title={
                  <Box pb={{ xs: '2px', md: '4px' }}>
                    <Typography
                      sx={{ fontSize: '12px', color: theme.palette.secondary.light, lineHeight: { xs: '16px', md: '14px' } }}
                    >
                      {t('security.password')}
                    </Typography>
                  </Box>
                }
                titleSx={{ minHeight: 0 }}
                description={
                  <Box sx={{ minHeight: { xs: '16px', md: '22px' } }}>
                    <Typography
                      sx={{ fontSize: '16px', lineHeight: { xs: '22px', md: '20px' }, fontWeight: 500, whiteSpace: 'pre-line' }}
                    >
                      {passwordChangeDate}
                    </Typography>
                  </Box>
                }
                dividerSx={{ mt: { xs: '14px', md: '19px' }, mb: { xs: '16px', md: '19px' }, ml: { xs: '52px', md: '56px' } }}
                fullWidth={true}
                hasUnderDivider={tsvEnabled}
              />
              {tsvEnabled && (
                <ListItem
                  icon={getSecurityIcon('Icon2sv', theme.palette.mode)}
                  iconSx={{ ...IconStyle }}
                  iconItemSx={{ minWidth: { xs: '52px', md: '56px' } }}
                  title={
                    <Box pb={{ xs: '2px', md: '4px' }}>
                      <Typography
                        sx={{ fontSize: '12px', color: theme.palette.secondary.light, lineHeight: { xs: '16px', md: '14px' } }}
                      >
                        {t('security.TSV')}
                      </Typography>
                    </Box>
                  }
                  titleSx={{ minHeight: 0 }}
                  description={
                    <Box sx={{ minHeight: { xs: '16px', md: '22px' } }}>
                      <Typography
                        sx={{ fontSize: '16px', lineHeight: { xs: '22px', md: '20px' }, fontWeight: 500, whiteSpace: 'pre-line' }}
                      >
                        {t('security.TSV.on')}
                      </Typography>
                    </Box>
                  }
                  fullWidth={true}
                />
              )}
            </List>
          </Box>
        </Stack>
      </Paper>
    </Box>
  )
}

export default CombinedCard
